import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import VoucherFormComments from '../../components/VoucherForm/Comment/VoucherFormComments';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import VoucherFormCustomer from '../../components/VoucherForm/Rules/AllowedCustomer/VoucherFormCustomer';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';

import styles from './add-voucher.module.scss';

const AddRebookingPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Credit',
    voucherType: 'Rebooking',
    reasonField: true,
    specificationLabel: 'Specification (Booking/ride no.)',
    specificationRequired: true,
  };

  const VoucherFormStructureTemplate = {
    prefix: 'CUS',
    length: 12,
  };

  const VoucherFormQuantityTemplate = {
    disabled: true,
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'credit_amount',
    showFreeAncillaries: false,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'coupon',
    disableAllowedPlatforms: false,
    disableValidity: false,
  };

  const VoucherFormCountriesAndLinesTemplate = {
    transportType: true,
  };

  return (
    <>
      <VoucherFormBanner title='Customer Service - Rebooking' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity template={VoucherFormQuantityTemplate} />
            <VoucherFormStructure template={VoucherFormStructureTemplate} />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
            <VoucherFormCustomer />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormComments />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddRebookingPage;
